var getWindowSize = function getWindowSize() {
  var isClient = typeof window === 'object';
  if (!isClient) {
    return undefined;
  }
  return window.innerWidth;
};
var isTouchDevice = function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};
export { getWindowSize, isTouchDevice };